import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-pressed", "disabled", "onClick"]


export default {
  __name: 'SegmentedControl',
  props: ['modelValue', 'options', 'disabled'],
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["inline-flex rounded-md shadow-sm", props.disabled && 'opacity-50 cursor-not-allowed']),
    role: "group"
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option, index) => {
      return (_openBlock(), _createElementBlock("button", {
        key: option.value,
        type: "button",
        "aria-pressed": option.value === props.modelValue,
        disabled: props.disabled,
        class: _normalizeClass(["relative px-3 py-2 text-sm font-medium whitespace-nowrap border focus:z-20 focus:outline-none focus:ring-1 focus:ring-brand-500", [
        index === 0 ? 'rounded-l-md' : '-ml-px',
        index === props.options.length - 1 && 'rounded-r-md',
        props.disabled && 'cursor-not-allowed',
        option.value === props.modelValue
          ? 'z-10 bg-brand-600 border-brand-600 text-white'
          : 'bg-white border-gray-300 text-gray-700',
        option.value !== props.modelValue && !props.disabled && 'hover:bg-gray-50'
      ]]),
        onClick: $event => (emit('update:modelValue', option.value))
      }, _toDisplayString(option.name), 11, _hoisted_1))
    }), 128))
  ], 2))
}
}

}